"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _textArea = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-area"));

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _Message = require("@insided/deprecated-control/ui-components/Message");

var IntegrationFilter = function IntegrationFilter(_ref) {
  var onContentChange = _ref.onContentChange,
      filterQuery = _ref.filterQuery,
      showFilterWarning = _ref.showFilterWarning,
      disabled = _ref.disabled;
  return (0, _preact.h)("div", {
    className: "integration-filter"
  }, (0, _preact.h)("div", {
    className: "integration-filter-title"
  }, "Filter search results"), (0, _preact.h)("div", {
    className: "integration-filter-label"
  }, "Results are filtered based on the query entered in the field. Custom fields can also be filtered. If the query is left empty, no filter will be applied and all results will be displayed."), (0, _preact.h)(_textArea.default, {
    disabled: disabled,
    isControl: true,
    onContentChange: onContentChange,
    placeholder: "",
    adjustHeight: true,
    value: filterQuery
  }), showFilterWarning && (0, _preact.h)(_Message.Message, {
    variant: "warning",
    fullWidth: true
  }, (0, _preact.h)("span", null, "Removing the default filter \u201Cstatus:published\u201D will display archived, draft and published content in community search.")), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "Learn how to write queries",
    url: "https://support.thoughtindustries.com/hc/en-us/articles/360046307253-Writing-a-Search-Query",
    isExternalLinkForToggle: false
  }));
};

var _default = IntegrationFilter;
exports.default = _default;